import FormControl from "@mui/material/FormControl"
import FormHelperText from "@mui/material/FormHelperText"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import { useCallback, useMemo } from "react"
import { Controller, useFormContext } from "react-hook-form"

export default function FormInputSelect({
	id,
	rules,
	defaultValue = "",
	label = "",
	data = [],
	dataId = null,
	dataLabel = null,
}) {
	const {
		control,
		formState: { errors },
	} = useFormContext()
	const getOptionField = useCallback((field) => {
		return field ? (option) => option[field] : (option) => option
	}, [])

	const valueControl = useMemo(() => getOptionField(dataId), [dataId, getOptionField])
	const labelControl = useMemo(
		() => getOptionField(dataLabel),
		[dataLabel, getOptionField]
	)

	return (
		<Controller
			name={id}
			control={control}
			defaultValue={defaultValue}
			{...{
				rules,
			}}
			render={({ field }) => (
				<FormControl fullWidth error={!!errors[id]}>
					<InputLabel id={`${id}-label`}>{label}</InputLabel>
					<Select labelId={`${id}-label`} id={id} label={label} {...field}>
						{data.map((option) => {
							const current = valueControl(option)
							return (
								<MenuItem key={current} value={current}>
									{labelControl(option)}
								</MenuItem>
							)
						})}
					</Select>
					<FormHelperText>
						{!!errors[id] ? errors[id]["message"] : ""}
					</FormHelperText>
				</FormControl>
			)}
		/>
	)
}
